import { render, staticRenderFns } from "./IngresantesCarrera.vue?vue&type=template&id=1e6c3bc9&scoped=true&"
import script from "./IngresantesCarrera.vue?vue&type=script&lang=js&"
export * from "./IngresantesCarrera.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e6c3bc9",
  null
  
)

export default component.exports